import { captureSentryError } from '../../shared/sentry/sentryUser';

export type CatalogSyncedPayload = {
  productsCount: number;
  categoriesCount: number;
  suppliersCount: number;
  brandsCount: number;
};

type CatalogSyncedHandler = (payload: CatalogSyncedPayload) => void | Promise<void>;

const handlers = new Set<CatalogSyncedHandler>();

export function subscribeCatalogSynced(handler: CatalogSyncedHandler): () => void {
  handlers.add(handler);
  return () => handlers.delete(handler);
}

export function publishCatalogSynced(payload: CatalogSyncedPayload): void {
  for (const handler of handlers) {
    try {
      const result = handler(payload);
      if (result && typeof (result as Promise<void>).then === 'function') {
        void (result as Promise<void>).catch((error) => {
          captureSentryError(error, { tags: { module: 'sync', op: 'catalog-synced-handler' } });
        });
      }
    } catch (error) {
      captureSentryError(error, { tags: { module: 'sync', op: 'catalog-synced-handler' } });
    }
  }
}
